<template>
  <div class="onlineRefund">
    <div class="onlineRefund-content">
        <div class="onlineRefund-item">
            <div class="onlineRefund-line">
                <div>预交金余额</div>
                <div>¥{{ prepaidBalance }}</div>
            </div>
            <div class="onlineRefund-line">
                <div>可退金额</div>
                <div>¥{{ refundableAmount }}</div>
            </div>
        </div>
        <div class="onlineRefund-i">
            <span>{{ patientName ? patientName.substring(0,1) + '**' : '**鹏' }}</span>
            <div>{{ hisCardNo ? hisCardNo.substring(0,2) + '******' + hisCardNo.substring(hisCardNo.length-2) : '00******55' }}</div>
        </div>
    </div>
    <div class="onlineRefund-info">
      <div class="onlineRefund-info-title">请填写卡片信息</div>
      <div class="onlineRefund-info-user">
        <van-field
          v-model="patientName"
          label-class="label-title"
          label="姓名"
          placeholder="请输入卡片的真实姓名"
          readonly
          disabled
        />
        <van-field
          v-model="idCard"
          label-class="label-title"
          label="身份证号"
          placeholder="请输入卡片的身份证"
          readonly
          disabled
          :rules="[
            {
              required: true,
              message: '请填写正确的身份证号',
              pattern:
                /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
            },
          ]"
        />
        <van-field
          v-model="phone"
          type="number"
          label-class="label-title"
          label="电话"
          placeholder="请输入卡片的联系电话"
          readonly
          disabled
          :rules="[
            {
              required: true,
              message: '请填写正确的手机号',
              pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
            },
          ]"
        />
        <van-field
            v-model="phoneCode"
            label-class="label-title"
            label="验证码"
            placeholder="请输入手机验证码"
            :rules="[{ required: true, message: '请填写短信验证码' }]"
        >
            <div 
              class="verification-code-btn" 
              :class="{ 'disabled': countdown > 0 }"
              slot="right-icon" 
              @click="sendVerificationCode"
            >
              {{ codeButtonText }}
            </div>
        </van-field>
      </div>
    </div>
    <div class="onlineRefund-info">
      <div class="onlineRefund-info-title">请选择退款路径</div>
      <div class="onlineRefund-info-user">
        <van-radio-group v-model="appointmentType">
            <van-cell-group>
                <van-cell clickable @click="appointmentType = '1'">
                    <img style="width: 1rem;margin-right: 1rem;vertical-align: text-bottom;" :src="require('@assets/WeChat.png')" alt="" />
                    <span style="font-size: .9rem;">退款至 微信零钱</span>
                    <van-radio slot="right-icon" name="1" />
                </van-cell>
                <van-cell clickable @click="appointmentType = '2'">
                    <img style="width: 1rem;margin-right: 1rem;vertical-align: text-bottom;" :src="require('@assets/alipy.png')" alt="" />
                    <span style="font-size: .9rem;">退款至 支付宝余额</span>
                    <van-radio slot="right-icon" name="2" />
                </van-cell>
            </van-cell-group>
        </van-radio-group>
      </div>
    </div>
    <div class="onlineRefund-info">
      <div class="onlineRefund-info-title">请填写退款信息</div>
      <div class="onlineRefund-info-user">
        <van-field
            v-model="refundAmount"
            type="number"
            label-class="label-title"
            label="退款金额"
            placeholder="请输入退款金额"
            :rules="[{ required: true, message: '请填写退款金额' }]"
        >
            <div style="font-size: .9rem;color: #108eee;" slot="right-icon" @click="setFullRefund">全额退款</div>
        </van-field>
        <van-field
            v-model="accountName"
            label-class="label-title"
            label="收款账户姓名"
            :placeholder="appointmentType == '1' ?'请输入微信实名认证姓名' : '请输入支付宝实名认证姓名'"
        />
        <van-field
            v-if="appointmentType == '2'"
            v-model="aliPayAccount"
            label-class="label-title"
            label="支付宝账号"
            placeholder="请输入支付宝账号"
            class="alipy-message"
            error-message="支付宝账号为注册时的邮箱或手机号"
        />
        <van-field
            v-model="phone"
            type="number"
            label-class="label-title"
            label="退款通知电话"
            placeholder="用于通知退款结果"
            :rules="[
                {
                required: true,
                message: '请填写正确的手机号',
                pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
                },
            ]"
        />
      </div>
    </div>
    <div class="onlineRefund-info-submit">
      <van-button 
        type="primary" 
        size="large" 
        round 
        block 
        :loading="submitting"
        loading-text="提交中..."
        @click="MedicalInsuranceMPIServiceClk"
        class="submit-button"
      >
        提交退款申请
      </van-button>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      dateInfo: "",
      query: {},
      patientInfo: null,
      appointmentType: "1",
      patientName: "",
      cardNo: "",
      phone: "",
      idCard: "",
      phoneCode: "", // 验证码
      refundAmount: "", // 退款金额
      appointmentInfo: [],
      prepaidBalance: 0, // 预交金余额
      refundableAmount: 0, // 可退金额
      accountName: "", // 收款账户姓名
      aliPayAccount: "", // 支付宝账号
      // HIS必要信息
      hisPatientId: "",
      hisCardNo: "",
      openId: "",
      submitting: false,
      // 验证码相关
      codeButtonText: "立即发送",
      countdown: 0,
    };
  },
  created() {
    this.getPatientBaseInfo();
  },
  methods: {
    ...mapActions("users", ["getUserBaseQrcodeInfo"]),
    // 获取病人基本信息
    getPatientBaseInfo() {
      this.$http
        .post(this.$api.USER_BASE_INFO, {
          functionType: "1",
          eleFlag: "0"
        })
        .then(res => {
          if (res) {
            // 填充用户基本信息
            this.patientName = res.patientName || "";
            this.idCard = res.idCard || "";
            this.phone = res.linkTel || ""; // 从 USER_BASE_INFO 接口获取电话号码
            this.accountName = res.patientName || ""; // 收款账户姓名默认为患者姓名
            
            // 填充余额信息
            this.prepaidBalance = res.prepay || 0;
            
            // 填充HIS信息
            this.hisPatientId = res.patientId || res.hisPatientId || "";
            this.hisCardNo = res.hisCardNo || res.cardNo || "";
            this.openId = res.openId || "";
            
            // 在获取病人信息后调用查询可退余额接口
            this.$nextTick(() => {
              this.queryCanRefundOrderSum();
            });
          }
        })
        .catch(err => {
          console.error("获取病人基本信息失败:", err);
          this.$dialog.alert({
            title: '提示',
            message: '请先绑卡后再进行退款操作'
          });
        });
    },
    // 查询可退余额
    queryCanRefundOrderSum() {
      // 构建与退款接口相同的入参
      const submitData = {
        sysId: "", // 系统ID，根据实际需要设置
        // 卡片信息
        name: this.patientName,
        idCardNumber: this.idCard,
        phone: this.phone,
        verificationCode: this.phoneCode,
        // 退款路径
        refundWay: this.appointmentType === '1' ? '24' : '25', // 24-微信 25-支付宝
        aliPayAccount: this.appointmentType === "2" ? this.aliPayAccount : "",
        // 退款信息
        refundAmount: this.refundAmount,
        recipientAccountName: this.accountName,
        refundNotificationPhone: this.phone,
        // HIS必要信息
        hisPatientId: this.hisPatientId,
        hisCardNo: this.hisCardNo,
        startDate: "", // 根据实际需要设置
        endDate: "", // 根据实际需要设置
        refundOrderNo: "", // 退款订单号，可能由后端生成
        openId: this.openId
      };

      this.$http
        .post("/refund/queryCanRefundOrderSum", submitData)
        .then(res => {
          console.log("queryCanRefundOrderSum接口返回:", res);
          if (res && res.sjktje !== undefined) {
            // 设置可退金额
            const sjktje = res.sjktje;
            console.log("sjktje原始值:", sjktje, "类型:", typeof sjktje);
            this.refundableAmount = parseFloat(sjktje) || 0;
            console.log("设置后的refundableAmount:", this.refundableAmount);
          } else {
            console.log("接口返回数据格式异常:", res);
          }
        })
        .catch(err => {
          console.error("查询可退余额失败:", err);
          this.$toast.fail("获取可退余额失败，请稍后重试");
        });
    },
    getPatientInfo() {
    },
    // 提交退款申请
    commit() {
      // 构建提交数据
      const submitData = {
        sysId: "", // 系统ID，根据实际需要设置
        // 卡片信息
        name: this.patientName,
        idCardNumber: this.idCard,
        phone: this.phone,
        verificationCode: this.phoneCode,
        // 退款路径
        refundWay: this.appointmentType === '1' ? '24' : '25', // 24-微信 25-支付宝
        aliPayAccount: this.appointmentType === "2" ? this.aliPayAccount : "",
        // 退款信息
        refundAmount: this.refundAmount,
        recipientAccountName: this.accountName,
        refundNotificationPhone: this.phone,
        // HIS必要信息
        hisPatientId: this.hisPatientId,
        hisCardNo: this.hisCardNo,
        startDate: "", // 根据实际需要设置
        endDate: "", // 根据实际需要设置
        refundOrderNo: "", // 退款订单号，可能由后端生成
        openId: this.openId
      };

      // 调用退款接口
      this.$http.post("/refund/yxRefund", submitData)
        .then(res => {
          this.submitting = false;
          console.log("退款接口返回数据:", res);
          console.log("退款方式:", this.appointmentType === '1' ? '微信' : '支付宝');
          
          // 调试用：显示接口返回参数
          // this.$dialog.alert({
          //   title: '调试信息 - /refund/yxRefund接口返回',
          //   message: `接口返回参数详情：\n\n${JSON.stringify(res, null, 2)}`
          // });
          
          // 注意：根据axiosUtil.js的处理逻辑，这里的res实际上是后端返回数据的entity部分
          if (res && res.result) {
            console.log("接口调用成功，result:", res.result);
            
            if (res.result === 'success') {
              console.log("退款处理成功");
              
              // 检查是否是微信退款且包含支付信息
              if (this.appointmentType === '1' && res.package_info) {
                console.log("微信退款，需要唤起微信JSAPI收款确认接口:", {
                  appid: res.appid,
                  mch_id: res.mch_id,
                  package_info: res.package_info,
                  system_id: res.system_id,
                  cardNo: res.cardNo,
                  patientId: res.patientId,
                  billsn: res.billsn,
                  hisddh: res.hisddh
                });
                
                // 调用微信JSAPI收款确认接口
                this.invokeWeChatReceiveConfirm({
                  appid: res.appid,
                  mch_id: res.mch_id,
                  package_info: res.package_info,
                  system_id: res.system_id,
                  id: res.id,
                  status: res.status,
                  cardNo: res.cardNo,
                  patientId: res.patientId,
                  billsn: res.billsn,
                  hisddh: res.hisddh,
                  timestamp: res.timestamp,
                  nonceStr: res.nonceStr,
                  signature: res.signature
                });
              } else {
                // 普通退款成功（支付宝或其他方式）
                this.$toast.success("退款申请提交成功");
                this.$router.push("/home");
              }
            } else {
              console.log("退款申请失败，result:", res.result, "status:", res.status);
              // 获取失败原因，优先使用 result 字段的信息
              const errorMsg = (res.result && res.result !== 'success') 
                ? res.result 
                : "退款申请提交失败";
              console.log("失败原因:", errorMsg);
              this.$toast.fail(errorMsg);
            }
          } else {
            console.log("接口返回格式异常:", res);
            const errorMsg = "退款申请提交失败";
            this.$toast.fail(errorMsg);
          }
        })
        .catch(err => {
          this.submitting = false;
          console.error("退款申请网络错误:", err);
          this.$toast.fail("网络错误，请稍后重试");
        });
    },

    // 提交退款按钮点击事件
    MedicalInsuranceMPIServiceClk() {
      // 表单验证
      if (!this.patientName) {
        this.$toast.fail("请输入姓名");
        return;
      }
      if (!this.idCard) {
        this.$toast.fail("请输入身份证号");
        return;
      }
      if (!this.phone) {
        this.$toast.fail("请输入电话号码");
        return;
      }
      if (!this.phoneCode) {
        this.$toast.fail("请输入验证码");
        return;
      }
      if (!this.refundAmount) {
        this.$toast.fail("请输入退款金额");
        return;
      }
      
      // 验证退款金额最小值
      const refundAmountNum = parseFloat(this.refundAmount);
      if (refundAmountNum < 0.1) {
        this.$toast.fail("退款金额最少要退0.1元");
        return;
      }
      
      // 验证微信渠道退款金额上限
      if (this.appointmentType === '1' && refundAmountNum > 10000) {
        this.$toast.fail("微信渠道单笔退款金额不能超过10000元");
        return;
      }
      if (!this.accountName) {
        this.$toast.fail("请输入收款账户姓名");
        return;
      }
      if (this.appointmentType === "2" && !this.aliPayAccount) {
        this.$toast.fail("请输入支付宝账号");
        return;
      }

      // 设置提交状态
      this.submitting = true;
      
      // 提交退款申请
      this.commit();
    },

    // 设置全额退款
    setFullRefund() {
      this.refundAmount = this.refundableAmount.toString();
    },

    // 发送验证码
    sendVerificationCode() {
      if (this.countdown > 0) {
        return;
      }
      
      if (!this.phone) {
        this.$toast.fail("请先输入手机号码");
        return;
      }
      
      // 验证手机号格式
      const phonePattern = /^1(3|4|5|6|7|8|9)\d{9}$/;
      if (!phonePattern.test(this.phone)) {
        this.$toast.fail("请输入正确的手机号码");
        return;
      }
      
      // 调用发送验证码接口
       this.$http.post("/refund/sendSms", {
         phone: this.phone,
         type: "refund" // 退款验证码类型
       })
      .then(res => {
        console.log("发送验证码接口返回:", res);
        if (res && res === "发送成功") {
          this.$toast.success(res || "验证码发送成功");
          this.startCountdown();
        } else {
          this.$toast.fail(res.message || res.entity || "验证码发送失败");
        }
      })
      .catch(err => {
        console.error("发送验证码失败:", err);
        this.$toast.fail("网络错误，请稍后重试");
      });
    },

    // 开始倒计时
    startCountdown() {
      this.countdown = 30; // 改为30秒倒计时
      this.codeButtonText = `${this.countdown}s后重发`;
      
      const timer = setInterval(() => {
        this.countdown--;
        if (this.countdown > 0) {
          this.codeButtonText = `${this.countdown}s后重发`;
        } else {
          this.codeButtonText = "立即发送";
          clearInterval(timer);
        }
      }, 1000);
    },

    // 调用微信商户转账到零钱接口
    invokeWeChatReceiveConfirm(refundData) {
      console.log("准备调用微信商户转账到零钱接口:", refundData);
      
      // 检查微信环境
      if (typeof wx === 'undefined') {
        console.error("微信JS-SDK未加载，无法调用微信API");
        this.$toast.fail("请在微信中打开此页面");
        this.callRefundConfirm(refundData, "微信JS-SDK未加载，无法调用微信API");
        return;
      }
      
      // 验证必要的退款参数
      if (!refundData.package_info || !refundData.appid || !refundData.mch_id) {
        console.error("缺少必要的退款参数");
        this.$toast.fail("退款参数不完整，请联系客服");
        this.callRefundConfirm(refundData, "退款参数不完整，请联系客服");
        return;
      }
      
      try {
        // 首先配置微信JS-SDK
        // 注意：实际项目中需要从后端获取正确的配置参数
        wx.config({
          debug: false, // 开启调试模式
          appId: refundData.appid, // 必填，公众号的唯一标识
          timestamp: refundData.timestamp, // 必填，生成签名的时间戳
          nonceStr: refundData.nonceStr, // 必填，生成签名的随机串
          signature: refundData.signature, // 必填，签名（需要从后端获取）
          jsApiList: ['requestMerchantTransfer'] // 必填，需要使用的JS接口列表
        });
        
        wx.ready(() => {
          console.log("微信JS-SDK配置成功，开始检查API支持");
          
          // 检查微信版本是否支持商户转账API
          wx.checkJsApi({
              jsApiList: ['requestMerchantTransfer'],
              success: (res) => {
                console.log("API检查结果:", res);
                
                if (res.checkResult['requestMerchantTransfer']) {
                  console.log("微信版本支持商户转账，开始调用转账接口");
                  
                  // 调用微信商户转账到零钱接口
                /* eslint-disable no-undef */
                WeixinJSBridge.invoke('requestMerchantTransfer', {
                  mchId: refundData.mch_id, // 商户号
                  appId: refundData.appid,  // 应用ID
                  package: refundData.package_info // 转账参数包
                }, (result) => {
                  console.log("微信商户转账结果:", result);
                  
                  if (result.err_msg === 'requestMerchantTransfer:ok') {
                    // 转账成功（注意：这里的成功只是页面展示成功，不代表实际转账成功）
                    console.log("微信转账确认成功");
                    // 转账成功时也调用退款确认接口
                    this.callRefundConfirm(refundData, "退款成功", "01");
                  } else if (result.err_msg === 'requestMerchantTransfer:cancel') {
                    // 用户取消转账
                    console.log("用户取消微信转账");
                    this.$toast.fail("用户取消操作");
                    this.callRefundConfirm(refundData, "用户取消操作");
                  } else {
                    // 转账失败，调用退款确认接口
                    console.error("微信转账失败:", result.err_msg);
                    alert("微信转账失败:"+result.err_msg);
                    this.callRefundConfirm(refundData, result.err_msg);
                  }
                });
              } else {
                console.error("微信版本不支持商户转账功能");
                alert("微信版本不支持商户转账功能:");
                // 微信版本不支持时调用退款确认接口
                this.callRefundConfirm(refundData, "微信版本不支持商户转账功能");
              }
            },
            fail: (error) => {
              console.error("API检查失败:", error);
              alert("API检查失败:"+res);
              // API检查失败时调用退款确认接口
              const errorMsg = JSON.stringify(error) || "微信API检查失败";
              this.callRefundConfirm(refundData, errorMsg);
            }
          });
        });
        
        wx.error((res) => {
          console.error("微信JS-SDK配置失败:", res);
          alert(`微信JS-SDK配置失败详情:\n\n错误类型: 微信JS-SDK配置失败\n时间戳: ${new Date().toLocaleString()}\n错误代码: ${res.errMsg || 'N/A'}\n错误描述: ${res.errMsg || '未知错误'}\n完整错误信息: ${JSON.stringify(res, null, 2)}`);
          // 微信配置失败时也调用退款确认接口
          const errorMsg = JSON.stringify(res) || "微信配置失败";
          // this.callRefundConfirm(refundData, errorMsg);
        });
        
      } catch (error) {
        console.error("处理微信转账时发生错误:", error);
        alert("处理微信转账时发生错误:"+error);
        // 处理异常时调用退款确认接口
        const errorMsg = error.message || error.toString() || "处理微信转账时发生未知错误";
        this.callRefundConfirm(refundData, errorMsg);
      }
    },

    // 调用退款确认接口
    callRefundConfirm(refundData, errorMessage, tkqrlx = "03") {
      // 获取调用堆栈信息
      const stack = new Error().stack;
      const callerInfo = stack ? stack.split('\n')[2] || 'unknown' : 'unknown';
      
      console.log("准备调用退款确认接口:", {
        refundData,
        errorMessage,
        tkqrlx,
        callerInfo
      });
      
      // 根据tkqrlx类型处理reason
      let reason;
      if (tkqrlx === "01") {
        // 成功情况，使用固定的成功消息
        reason = "退款成功";
      } else {
        // 失败情况，截取错误信息前100个字符
        reason = errorMessage ? errorMessage.substring(0, 100) : "微信退款失败";
      }
      
      const confirmData = {
        cardNo: refundData.cardNo,
        patientId: refundData.patientId,
        billsn: refundData.billsn,
        hisddh: refundData.hisddh,
        system_id: refundData.system_id,
        tkqrlx: tkqrlx, // 动态设置："01"表示成功，"03"表示失败
        reason: reason,
        out_trade_no: refundData.id
      };
      
      console.log("退款确认接口参数:", confirmData);
      
      this.performRefundConfirm(confirmData, tkqrlx);
    },
    
    // 执行退款确认接口调用
    performRefundConfirm(confirmData, tkqrlx) {
      // 根据tkqrlx判断调用不同的接口
      let apiUrl, requestData;
      
      if (tkqrlx === "01") {
        // 微信转账成功时调用查询接口
        apiUrl = "/refund/queryRefund";
        requestData = {
          cardNo: confirmData.cardNo,
          patientId: confirmData.patientId,
          billsn: confirmData.billsn,
          hisddh: confirmData.hisddh,
          system_id: confirmData.system_id || confirmData.out_trade_no
        };
      } else {
        // 其他情况仍使用原接口
        apiUrl = "/refund/refundTkqr";
        requestData = confirmData;
      }
      
      this.$http.post(apiUrl, requestData)
        .then(res => {
          console.log("退款确认接口返回:", res);
          if (res && res.result === 'success') {
            if (tkqrlx === "01") {
              // 成功确认
              this.$toast.success("退款处理成功，资金将转入您的微信零钱");
            } else {
              // 失败确认
              this.$toast.success("退款申请已提交，请等待处理结果");
            }
            this.$router.push("/home");
          } else {
            const errorMsg = res.message || res.result || "退款确认失败";
            this.$toast.fail(errorMsg);
          }
        })
        .catch(err => {
          console.error("退款确认接口调用失败:", err);
          this.$toast.fail("退款确认失败，请联系客服");
        });
    },
  },
};
</script>

<style lang="less">
.onlineRefund {
  min-height: 100vh;
  padding: 0.5rem;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  box-sizing: border-box;

  &-content {
    padding: 1rem;
    color: white;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 1rem;
    font-size: 1.21rem;
    box-shadow: 0 8px 32px rgba(102, 126, 234, 0.3);
    margin-bottom: 1rem;
    
    span {
      font-size: 0.88rem;
    }
  }
  
  &-item {
    opacity: 0.9;
    display: flex;
    justify-content: space-between;
    margin-bottom: 1rem;
  }
  
  &-line {
    display: flex;
    flex-direction: column;
    align-items: center;
    
    div:first-child {
      font-size: 0.9rem;
      opacity: 0.8;
      margin-bottom: 0.3rem;
    }
    
    div:last-child {
      font-size: 1.4rem;
      font-weight: bold;
    }
  }
  
  &-i {
    display: flex;
    opacity: 0.8;
    font-size: 0.9rem;
    margin-top: 1rem;
    
    span {
      margin-right: 1rem;
    }
  }

  &-info {
    margin: 1rem 0;
    padding: 1rem;
    background: white;
    border-radius: 1rem;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    border: 1px solid rgba(102, 126, 234, 0.1);
    
    &-title {
      margin-bottom: 0.8rem;
      font-weight: 600;
      font-size: 1.1rem;
      color: #333;
      position: relative;
      padding-left: 0.8rem;
      
      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 4px;
        height: 1.2rem;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        border-radius: 2px;
      }
    }

    &-type {
      display: flex;
      justify-content: space-around;
      padding: 0.3rem 20%;
    }

    .van-cell {
      padding: 0.8rem 0;
      border-radius: 0.5rem;
      margin-bottom: 0.5rem;
      transition: all 0.3s ease;
      
      &:hover {
        background-color: #f8f9ff;
      }
    }
    
    .van-cell::after {
      border-color: rgba(102, 126, 234, 0.1);
    }
    
    .van-field {
      border-radius: 0.5rem;
      margin-bottom: 0.5rem;
      
      &__control {
        font-size: 1rem;
        color: #333;
      }
      
      &__label {
        color: #555;
        font-weight: 500;
      }
      
      &__control:disabled {
        color: #999;
      }
    }
    
    .label-title {
      font-size: 1rem;
      color: #555;
    }

    &-user {
      border-bottom: 1px solid rgba(102, 126, 234, 0.1);
    }

    &-tips {
      padding: 1rem 0;
      font-size: 1rem;
      
      h4 {
        margin: 0;
        color: #333;
      }
      
      span {
        color: #666;
        font-size: 0.9rem;
      }
    }
    
    &-submit {
      margin: 1.5rem 0 0.5rem;
      padding: 0 1rem;
      
      .submit-button {
        height: 3rem;
        font-size: 1.1rem;
        font-weight: 600;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        border: none;
        box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
        transition: all 0.3s ease;
        
        &:active {
          transform: translateY(1px);
          box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
        }
        
        &.van-button--loading {
          background: linear-gradient(135deg, #a8a8a8 0%, #999 100%);
        }
      }
    }
  }
  
  .alipy-message .van-field__error-message {
    color: #ff6b6b;
    font-weight: 500;
    font-size: 0.85rem;
  }
  
  // 验证码按钮样式
  .verification-code-btn {
    font-size: 0.9rem;
    color: #667eea;
    font-weight: 600;
    padding: 0.4rem 1rem;
    border-radius: 1.2rem;
    background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);
    border: 1px solid rgba(102, 126, 234, 0.3);
    transition: all 0.3s ease;
    cursor: pointer;
    user-select: none;
    
    &:hover {
      background: linear-gradient(135deg, rgba(102, 126, 234, 0.15) 0%, rgba(118, 75, 162, 0.15) 100%);
      border-color: rgba(102, 126, 234, 0.5);
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
    }
    
    &:active {
      transform: translateY(0);
      box-shadow: 0 2px 8px rgba(102, 126, 234, 0.15);
    }
    
    &.disabled {
      color: #999;
      background: #f5f5f5;
      border-color: #ddd;
      cursor: not-allowed;
      
      &:hover {
        transform: none;
        box-shadow: none;
        background: #f5f5f5;
        border-color: #ddd;
      }
    }
  }
  
  // 全额退款按钮样式
  .van-field [slot="right-icon"]:not(.verification-code-btn) {
    color: #667eea !important;
    font-weight: 500;
    padding: 0.3rem 0.8rem;
    border-radius: 1rem;
    background: rgba(102, 126, 234, 0.1);
    
    &:active {
      background: rgba(102, 126, 234, 0.2);
    }
  }
}
</style>
